import React from "react";
import { Link } from "react-router-dom";

const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="breadcrumb" className="help-breadcrumbs">
      <ol className="help-breadcrumbs-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="help-breadcrumbs-item">
              {index > 0 && <span className="help-breadcrumbs-separator">›</span>}
              {item.to && !isLast ? (
                <Link to={item.to} className="help-breadcrumbs-link">
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`help-breadcrumbs-current ${
                    item.muted ? "is-muted" : ""
                  }`}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
